export default __webpack_public_path__ + "static/media/profit.187e7f8e.svg";